import { FilterOptionsState } from "@mui/material";

import matchesAllSearchTokens from "~/helpers/search/tokenizedMatch";

interface FilterGenericOptionsFlags {
	rankExactMatchFirst?: boolean;
	tokenizedFilter?: boolean;
}

export const exactMatchFirst = <T>(
	rows: readonly T[],
	query: string,
	fields: (row: T) => ReadonlyArray<string | undefined>
): T[] => {
	const needle = query.trim().toLowerCase();
	if (!needle) {
		return [...rows];
	}
	const isExact = (row: T): boolean => fields(row).some((field) => (field ?? "").toLowerCase() === needle);
	return [...rows].sort((a, b) => Number(isExact(b)) - Number(isExact(a)));
};

export const filterGenericOptions = <T extends { code: string; name: string }>(
	options: T[],
	{ inputValue }: FilterOptionsState<T>,
	{ rankExactMatchFirst, tokenizedFilter }: FilterGenericOptionsFlags
): T[] => {
	const matches = options.filter((option) =>
		tokenizedFilter
			? matchesAllSearchTokens([option.code, option.name], inputValue)
			: option.code.toLowerCase().includes(inputValue.toLowerCase()) ||
				option.name.toLowerCase().includes(inputValue.toLowerCase())
	);
	return rankExactMatchFirst ? exactMatchFirst(matches, inputValue, (option) => [option.code, option.name]) : matches;
};
